declare let mxGeometryChange: any; // available globally
declare let mxStyleChange: any; // available globally
declare let mxTerminalChange: any; // available globally
import {
  isActivity,
  isConnector,
  isTerminator
} from '../../diagram-render/helpers/shapes-detectors.util';
import {setConnectionPoints} from '../../diagram-render/helpers/setConnectionPoints';
import * as _ from 'lodash';

export function flowlineGraphChange(graph, cell, change, allChanges) {
  const geometry = cell.geometry.clone();
  const source = cell.source;
  const target = cell.target;
  const waypoints = [];
  let srcType = 'none',
    tgtType = 'none',
    srcId = 0,
    tgtId = 0,
    srcPosition = null,
    tgtPosition = null;

  setConnectionPoints(cell, graph);

  const exitX = graph.getCellStyle(cell).exitX;
  const exitY = graph.getCellStyle(cell).exitY;
  const entryX = graph.getCellStyle(cell).entryX;
  const entryY = graph.getCellStyle(cell).entryY;

  if (source) {
    if (isActivity(source)) {
      srcType = 'activity';
    } else if (isConnector(source)) {
      srcType = 'connector';
    } else if (isTerminator(source)) {
      srcType = 'terminator';
    }

    srcId = source.id;
  }

  if (target) {
    if (isActivity(target)) {
      tgtType = 'activity';
    } else if (isConnector(target)) {
      tgtType = 'connector';
    } else if (isTerminator(target)) {
      tgtType = 'terminator';
    }

    tgtId = target.id;
  }

  if (geometry.sourcePoint && !source) {
    srcPosition = {x: geometry.sourcePoint.x, y: geometry.sourcePoint.y};
  }

  if (geometry.targetPoint && !target) {
    tgtPosition = {x: geometry.targetPoint.x, y: geometry.targetPoint.y};
  }

  if (geometry && geometry.points && geometry.points.length) {
    for (let j = geometry.points.length; j--; ) {
      const point = geometry.points[j];

      if (point && (point.x || point.y)) {
        waypoints.unshift({x: point.x, y: point.y});
      }
    }
  }

  const text = graph.getEditingValue(cell);

  const offset = {x: 0, y: 0};

  if (cell.geometry.offset) {
    offset.x = cell.geometry.offset.x || 0;
    offset.y = cell.geometry.offset.y || 0;
  }

  const textPosition: any = {
    x: geometry.x || 0,
    y: geometry.y || 0,
    offset: offset,
    connectionPoints: {}
  };

  if (!isNaN(exitX)) {
    textPosition.connectionPoints.exitX = exitX;
  }

  if (!isNaN(exitY)) {
    textPosition.connectionPoints.exitY = exitY;
  }

  if (!isNaN(entryX)) {
    textPosition.connectionPoints.entryX = entryX;
  }

  if (!isNaN(entryY)) {
    textPosition.connectionPoints.entryY = entryY;
  }

  const action: any = {
    mxKey: +cell.id,
    waypoints: waypoints,
    position: textPosition
  };

  if (srcPosition) {
    action.srcPosition = srcPosition;
  }

  if (tgtPosition) {
    action.tgtPosition = tgtPosition;
  }

  // check if it is only geometry change
  const notGeometryChanges = _.find(allChanges, ch => {
    return ch.cell && cell.id === ch.cell.id && !(ch instanceof mxGeometryChange);
  });

  action.text = text;

  if (notGeometryChanges) {
    action.srcType = srcType;
    action.tgtType = tgtType;

    if (srcType !== 'none') {
      action.srcId = srcId;
    }

    if (tgtType !== 'none') {
      action.tgtId = tgtId;
    }
  }

  const onlyStyleChange = _.every(allChanges, ch => {
    return ch.cell && ch instanceof mxStyleChange;
  });

  if (!cell.skipUndo) {
    if (!onlyStyleChange) {
      return {
        data: _.cloneDeep(action),
        action: 'changeFlowline',
        type: 'flowline',
        mxKey: Number(cell.id)
      };
    }
  }
}
